import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTelegram } from '../hooks/useTelegram';

export function ReviewsPage(): React.JSX.Element {
  const navigate = useNavigate();
  const { tg } = useTelegram();
  const [reviews] = useState([
    { id: 1, author: 'Анна', rating: 5, text: 'Отличный сервис, мастер Дмитрий просто волшебник!', date: '12.05.2026' },
    { id: 2, author: 'Иван', rating: 4, text: 'Все хорошо, но пришлось подождать 5 минут.', date: '10.05.2026' },
  ]);

  return (
    <div className="animate-in fade-in pb-20">
      <div className="flex items-center gap-4 mb-6">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 bg-black/5 dark:bg-white/5 rounded-full flex items-center justify-center text-xl"
        >
          ←
        </button>
        <h1 className="text-2xl font-bold">⭐ Отзывы</h1>
      </div>

      <div className="space-y-4">
        {reviews.length === 0 ? (
          <div className="text-center py-20 opacity-50">
            <div className="text-4xl mb-2">💬</div>
            <p>Отзывов пока нет</p>
          </div>
        ) : (
          reviews.map(review => (
            <div key={review.id} className="bg-tg-theme-bg p-5 rounded-3xl border border-black/5 shadow-sm">
              <div className="flex justify-between items-start mb-2">
                <div className="font-bold">{review.author}</div>
                <div className="text-xs text-tg-theme-hint">{review.date}</div>
              </div>
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className={i < review.rating ? 'text-yellow-500' : 'text-gray-300'}>⭐</span>
                ))}
              </div>
              <p className="text-sm leading-relaxed">{review.text}</p>
              
              <div className="mt-4 pt-4 border-t border-black/5 flex justify-end">
                <button 
                  onClick={() => tg?.showAlert('Функция ответа в разработке')}
                  className="text-xs font-bold text-blue-500 bg-blue-500/10 px-3 py-1.5 rounded-lg"
                >
                  Ответить
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
